import { render, staticRenderFns } from "./NoMarketplacesOnboardedorOnboarding.vue?vue&type=template&id=0566b45a&"
import script from "./NoMarketplacesOnboardedorOnboarding.vue?vue&type=script&lang=ts&"
export * from "./NoMarketplacesOnboardedorOnboarding.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports